<template>
  <div class="component-choose">
    <div class="tabs-and-status">
      <div class="tabs">
        <div
          :class="current === 0 ? 'tab' : 'no-show-list'"
          @click="showList()"
        >
          <a-popover trigger="hover" placement="left">
            <template slot="content">{{current===0 ? '展开':'收回'}}</template>
            <img :src="listImg" style="width: 16px; height: 13.8px" alt="" />
          </a-popover>
        </div>

        <div :class="current === 1 ? 'tabChoose' : 'tab'" @click="selectTab(1)">
          <a-popover trigger="hover" placement="left">
            <template slot="content">默认组件库</template>
            <img
              :src="defaultComponentImg"
              :class="current === 1 ? '' : 'no-choose'"
              style="width: 16px; height: 16px"
              alt=""
            />
          </a-popover>
        </div>
        <div :class="current === 2 ? 'tabChoose' : 'tab'" @click="selectTab(2)">
          <a-popover trigger="hover" placement="left">
            <template slot="content">项目组件库</template>
            <img
              :src="componentImg"
              style="width: 16px; height: 16px"
              alt=""
              :class="current === 2 ? '' : 'no-choose'"
            />
          </a-popover>
        </div>
        <div :class="current === 3 ? 'tabChoose' : 'tab'" @click="selectTab(3)">
          <a-popover trigger="hover" placement="left">
            <template slot="content">组件树</template>
            <img
              :src="componentTreeImg"
              :class="current === 3 ? '' : 'no-choose'"
              style="width: 16px; height: 16px"
              alt=""
            />
          </a-popover>
        </div>
      </div>
      <div class="status">
        <div class="tab">
          <img :src="myselfImg" style="width: 16px; height: 16px" alt="" />
        </div>
        <div class="tab">
          <img :src="settingImg" style="width: 16px; height: 16px" alt="" />
        </div>
      </div>
    </div>
    <Default-Component @createSortables="createSortables" @setComponentList="setComponentList" v-if="current === 1" />
    <Show-Component @createSortables="createSortables" @setComponentList="setComponentList" v-if="current === 2" />
    <Show-ComponentTree v-if="current === 3" />
  </div>
</template>
<script>
import _ from "lodash";
import Vue from 'vue'
import { PAGE_UNDO_PREFIX, PAGE_REDO_PREFIX } from "@/store/mutation-types";
import {mapMutations} from 'vuex';
import jiff from "jiff";
import Page from "@/utils/Page.js";
import BlockComponent from "@/utils/BlockComponent.js";
import bus from '@/utils/Bus';
import Sortable from "sortablejs";
import componentApi from "@/request/api-manager/component.js";
import ShowComponentTree from "@/views/edit-page/component-choose/show-component-tree/ShowComponentTree.vue";
import ShowComponent from "@/views/edit-page/component-choose/show-component/ShowComponent.vue";
import DefaultComponent from "@/views/edit-page/component-choose/default-component/DefaultComponent.vue";
export default {
  name: "ComponentChoose",
  props: {
    current: {
      type: Number,
    },
    project: {
      type: Object,
      default: (() => {})
    },
    pageObj: {
      type: Object,
      default: (() => {})
    }
  },
  data() {
    return {
      page: null,
      listImg: require("@/assets/edit-page/list.png"),
      componentImg: require("@/assets/edit-page/component.png"),
      componentTreeImg: require("@/assets/edit-page/componentTree.png"),
      myselfImg: require("@/assets/edit-page/myself.png"),
      settingImg: require("@/assets/edit-page/setting.png"),
      componentWhiteImg: require("@/assets/edit-page/componentWhite.png"),
      addimg: require("@/assets/edit-page/add.png"),
      defaultComponentImg: require("@/assets/edit-page/defaultComponent.png"),
      componentList: [],
      addComponentDom: null,
      pageSortable: []
    };
  },
  components: {
    ShowComponent,
    ShowComponentTree,
    DefaultComponent,
  },
  mounted() {
    // 初始化监听事件
    this.addEventListener();
  },
  methods: {
    ...mapMutations(['setUndoList', 'setRedoList']),
    /**
     * 页面视图初始化
     * @return {Boolean} 结果
     */
    initPageLive() {
      let self = this;
      self.page = new Page({ ...self.pageObj });
      console.log('page', self.page)
      return new Promise((resolve) => {
        componentApi
          .initPageLive({
            projectId: self.page.component.projectId,
            pageId: self.page.component.id
          })
          .then(async (res) => {
            if (res.success) {
              if (res.result.pageJson == null || res.result.pageJson == ""){
                await this.updatePage()
              }else{
                self.page = Page.fromJSON(JSON.parse(res.result.pageJson));
                this.initPageCache(self.page.toJSON())
              }
              self.initIframe(res.result.port);
              self.setCookiePort(res.result.port);
              // 选择页面
              self.cancelSelect()
              resolve(true);
            } else {
              self.$message.error("page视图初始化失败！");
              resolve(false);
            }
          });
      });
    },

    initPageCache(page){
      // page缓存数组为空则插入缓存，不为空则判断和数组最后一个元素是否相等，相等则不插入，不相等则插入
      let pageId = page.component.id
      let undoList = Vue.ls.get(PAGE_UNDO_PREFIX + pageId)

      if(undoList && undoList.length > 0){
        let diff = _.filter(jiff.diff(undoList[undoList.length - 1], page), item => item.value || item.op == "remove")
        console.log('diff',diff)
        if(diff.length != 0) 
          undoList.push(page)
      }else{
        undoList = [page]
      }

      Vue.ls.set(PAGE_UNDO_PREFIX + pageId, undoList)
      this.setUndoList(undoList)
    },

    getPageUpdatePatch(page){
      let pageId = page.component.id
      let undoList = Vue.ls.get(PAGE_UNDO_PREFIX + pageId)
      let newPage = page
      let oldPage;

      if(undoList && undoList.length > 0){
        oldPage = undoList[undoList.length - 1]
        undoList.push(newPage)
      }else{
        oldPage = {}
        undoList = [newPage]
      }

      Vue.ls.set(PAGE_UNDO_PREFIX + pageId, undoList)
      Vue.ls.remove(PAGE_REDO_PREFIX + pageId)
      this.setUndoList(undoList)
      this.setRedoList([])
      console.log('diff', jiff.diff(oldPage, newPage), oldPage, newPage)
      return jiff.diff(oldPage, newPage)
    },

    getPageUndoPatch(pageId){
      // let pageId = page.component.id
      let undoList = Vue.ls.get(PAGE_UNDO_PREFIX + pageId)
      let redoList = Vue.ls.get(PAGE_REDO_PREFIX + pageId)
      let oldPage = undoList.pop();
      let newPage = undoList[undoList.length - 1];
      if(redoList){
        redoList.push(oldPage)
      }else{
        redoList = [oldPage]
      }
      
      Vue.ls.set(PAGE_UNDO_PREFIX + pageId, undoList)
      Vue.ls.set(PAGE_REDO_PREFIX + pageId, redoList)
      this.setUndoList(undoList)
      this.setRedoList(redoList)
      this.page = Page.fromJSON(newPage)
      return jiff.diff(oldPage, newPage)
    },

    getPageRedoPatch(pageId){
      // let pageId = page.component.id
      let undoList = Vue.ls.get(PAGE_UNDO_PREFIX + pageId)
      let redoList = Vue.ls.get(PAGE_REDO_PREFIX + pageId)
      let newPage = redoList.pop();
      let oldPage = undoList[undoList.length - 1];
      undoList.push(newPage)
      Vue.ls.set(PAGE_UNDO_PREFIX + pageId, undoList)
      Vue.ls.set(PAGE_REDO_PREFIX + pageId, redoList)
      this.setUndoList(undoList)
      this.setRedoList(redoList)
      this.page = Page.fromJSON(newPage)
      return jiff.diff(oldPage, newPage)
    },

    /**
     * 页面视图初始化
     * @param {String} url page视图url
     * @return {Boolean} 结果
     */
    initIframe(port) {
      let previewIframe = this.createIframeDom("preview")
      let pageIframe = this.createIframeDom("page")
      document.getElementById("iframe-div").appendChild(previewIframe);
      document.getElementById("iframe-div").appendChild(pageIframe);
    },

    /**
     * 创建Iframe元素
     */
    createIframeDom(type){
      var iframe = document.createElement("iframe");
      iframe.style.border = "none";
      iframe.style.zIndex = "-1";
      if(type == "page")
        iframe.style.display = "none";
      Object.assign(iframe, {
        id: `iframe-${type}`,
        src: `/${type}/${this.page.component.id}`,
        scrolling: "no",
        // src: `http://localhost:${port}/haomo/${self.pageId}/page-preview`,
        height: "100%",
        width: "100%",
      });
      return iframe
    },

    /**
     * 设置cookie为当前项目的端口号
     */
    setCookiePort(port) {
      this.$cookies.remove("x-port");
      this.$cookies.set("x-port", port);
    },

    /**
     * 初始化Sortable对象
     */
    initSortable() {
      // 初始化Sortable
      this.$nextTick(() => {
        var els = this.$refs.showComponent;
        els.forEach((el) => {
          // 创建组件Sortable对象
          this.createSortable(el);
        });
      });
    },

    /**
     * 创建Sortables拖拽对象
     * @param {*} els dom对象数组
     */
    createSortables(els){
      console.log('els', els)
      els.forEach((el) => {
        // 创建组件Sortable对象
        this.createSortable(el);
      });
    },

    /**
     * 创建Sortable拖拽对象
     * @param {*} el dom对象
     */
    createSortable(el) {
      let self = this;
      Sortable.create(el, {
        sort: false,
        group: { name: "shared", pull: "clone", put: false },
        animation: 150,
        onEnd: function (evt) {
          if(evt.to.className == "sortable-list")
            self.addComponent(evt);
        },
      });
    },

    /**
     * 组件添加
     * @param {*} evt sortable event
     */
    async addComponent(evt) {
      let self = this;
      
      let component = _.find(self.componentList, { id: evt.item.id });
      // 获取组件code字段
      // if (!component.isBuiltIn && !(await self.getComponenCode(component))) {
      //   this.$message.error("组件代码不存在！");
      //   return;
      // }
      // 导入组件并获取代码
      if (!(await self.importPageComponent(self.page.component.projectId,component))) {
        this.$message.error("组件导入失败！");
        return;
      }
      // page页面添加组件
      self.addPageComponent(evt.item, await BlockComponent.create(component));
      // 删除原item
      // evt.item.parentNode.removeChild(evt.item);
    },

    /**
     * 获取组件code字段
     * @param {*} component 组件对象
     */
    // async getComponenCode(component) {
    //   let res = component.isBuiltIn ? 
    //     await componentApi.getBuiltInCode({
    //       componentUrl: component.importPath
    //     }) :
    //     await componentApi.getCodeByUrlAndFrameName({
    //       componentUrl: component.fileUrl,
    //       frameName: "vue",
    //     })
      
    //   if (!res.success) return false

    //   component.code = res.result;

    //   return true
    // },

    /**
     * 添加监听事件
     */
    addEventListener() {
      // 添加iframe监听事件
      window.addEventListener(
        "message",
        (e) => {
          if(e.data.type)
            this.handlePageMessage(e.data)
        },
        false
      );
      // 添加清空页面监听事件
      bus.$on("clear-page", () => {
        this.clearPage()
      });
      // 添加撤回页面监听事件
      bus.$on("undo-page", () => {
        this.undoPage()
      });
      // 添加重做页面监听事件
      bus.$on("redo-page", () => {
        this.redoPage()
      });
    },

    /**
     * 处理page页面监听消息
     * @param {*} message 监听消息
     */
    handlePageMessage(message) {
      switch (message.type) {
        case "init":
          this.$emit('cancelLoading')
          this.initPageSortable(message.data);
          return;
        case "delete":
          this.deletePageComponent(message.data)
          return
        case "select":
          this.onSelectComponent(message.data)
          return
        case "cancel-select":
          this.cancelSelect(message.data)
          return
        // case "update":
        //   this.delAddComponentDom()
        //   return
      }
    },
    
    /**
     * page页面--初始化Sortable对象
     */
    initPageSortable() {
      let self = this
      // let pageSortable = []
      var iframe = document.getElementById("iframe-preview");
      var doc = iframe.contentDocument || iframe.contentWindow.document;
      var els = doc.getElementsByClassName("sortable-list");
      // console.log("els", els, els.length);
      if (els.length > 0)
        for (let i = 0; i < els.length; i++)
          Sortable.create(els[i], {
            handle: ".view-drag,.component-item",
            group: {
              name: "shared",
            },
            animation: 150,
            onEnd: function (evt) {
              if(evt.to.className == "sortable-list")
                self.movePageComponent(evt);
            },
          });
      // this.pageSortable = pageSortable
      // console.log('pageSortable', this.pageSortable)
    },

    // refreshPageSortable(){
    //   this.pageSortable.forEach(sortable => {
    //     sortable.destroy()
    //   })
    //   this.initPageSortable()
    // },

    /**
     * 删除添加组件的dom元素
     */
    // delAddComponentDom() {
    //   if(this.addComponentDom != null){
    //     this.refreshPageSortable()
    //     this.addComponentDom.parentNode.removeChild(this.addComponentDom)
    //     this.addComponentDom = null
    //   } 
    // },

    cancelSelect() {
      console.log("cancel-select")
      bus.$emit('cancel-select', this.page);
    },

    onSelectComponent(componentKey) {
      let blockComponent = this.page.getBlockComponent(componentKey)
      console.log(`emit bus message select-component: ${componentKey}, `, blockComponent, this.page)
      bus.$emit('select-component', blockComponent);
    },

    /**
     * page页面--组件添加
     * @param {*} item 组件dom对象
     */
    async addPageComponent(item, blockComponent) {
      // 获取component属性
      let self = this;
      self.addComponentDom = item

      let previousItem = item.previousElementSibling;
      let parentItem = self.getCardParentItem(item);

      let afterComponentKey = previousItem ? previousItem.id : null;
      let parentKey = parentItem
        ? parentItem.id != ""
          ? parentItem.id
          : null
        : null;
      let hmBlockDom = item.parentNode.parentNode
      console.log('hmBlockDom', hmBlockDom, hmBlockDom.getAttribute("data-slot-name"))
      // if(item.parentItem.parentItem )
      blockComponent.note.slot = {
        name: hmBlockDom.getAttribute("data-slot-name") || "default"
      }

      console.log("addComponent", afterComponentKey, blockComponent, parentKey);
      self.page.addComponent(afterComponentKey, blockComponent, parentKey);
      // 调用渲染接口
      if (!(await self.updatePage())) {
        this.$message.error("页面渲染失败,请刷新页面！");
        return;
      }
      // item.parentNode.removeChild(item);
      console.log("page", this.page);
    },

    /**
     * 递归查找item上个节点class为card的元素
     * @param {*} item
     */
    getCardPreviousItem(item) {
      let previousItem = item.previousElementSibling;
      if (!previousItem) return null;
      if (previousItem && previousItem.className != "card")
        return this.getCardPreviousItem(previousItem);
      return previousItem;
    },

    /**
     * 递归查找item父节点class为card的元素
     * @param {*} item
     */
    getCardParentItem(item) {
      let parentItem = item.parentNode;
      console.log("父亲", parentItem);
      if (!parentItem) return null;
      if (parentItem.className == "hm-block")
        return parentItem;
      return this.getCardParentItem(parentItem);
    },

    /**
     * page页面--导入组件
     * @param {*} pageId 组件ID
     */
    async importPageComponent(projectId, component) {
      // return new Promise((resolve) => {
      let res = await componentApi.import({
        projectId,
        projectName: component.projectName || "", 
        componentName: component.name, 
        componentUrl: component.fileUrl || component.importPath,
        frameName: "vue",
        isBuiltIn: component.isBuiltIn || false
      })
      if (!res.success) return false

      component.code = res.result;

      return true
    },

    /**
     * page页面--组件移动
     * @param {*} item 组件ID
     */
    async movePageComponent(evt) {
      // 获取component属性
      let self = this;
      let item = evt.item
      let previousItem = item.previousElementSibling;
      let parentItem = self.getCardParentItem(item);
      
      let afterComponentKey = previousItem ? previousItem.id : null;
      let parentKey = parentItem
        ? parentItem.id != ""
          ? parentItem.id
          : null
        : null;
      console.log("moveComponent", item.id, afterComponentKey, parentKey);
      this.page.moveComponent(item.id, afterComponentKey, parentKey);
      // 调用渲染接口
      if (!(await this.updatePage())) {
        this.$message.error("页面渲染失败,请刷新页面！");
        return;
      }
    },

    /**
     * page页面--组件删除
     * @param {*} item 组件ID
     */
    async deletePageComponent(id) {
      this.page.delComponent(id);
      // 调用渲染接口
      if (!(await this.updatePage())) {
        this.$message.error("页面渲染失败,请刷新页面！");
        return;
      }
    },

    /**
     * page页面-清空页面
     * @param {*} page page对象
     */
    clearPage(){
      console.log('page',this.page)
      this.page = new Page({...this.page.component})
      this.updatePage()
    },

    /**
     * page页面--更新
     * @param {*} page page对象
     */
    async updatePage() {
      // 根据缓存获取patch并更新缓存
      console.log('updatePage', this.page, this.page.toJSON())
      let patch = this.getPageUpdatePatch(this.page.toJSON())
      if(!await this.renderPage(patch))
        return false;
      return true
    },

    /**
     * page页面--撤回
     * @param {*} page page对象
     */
    async undoPage() {
      // 根据缓存获取patch并更新缓存
      let patch = this.getPageUndoPatch(this.page.component.id)
      if(!await this.renderPage(patch))
        return false;
      return true
    },

    /**
     * page页面--重做
     * @param {*} page page对象
     */
    async redoPage() {
      // 根据缓存获取patch并更新缓存
      let patch = this.getPageRedoPatch(this.page.component.id)
      if(!await this.renderPage(patch))
        return false;
      return true
    },

    /**
     * page页面--渲染
     * @param {*} page page对象
     */
    async renderPage(patch) {
      // 根据缓存获取patch并更新缓存
      console.log('patch', patch)
      patch = _.filter(patch, item => (item.value && item.op != "test") || item.op == "remove" )
      console.log('patch', patch)
      let res = await componentApi.genPageCode({patch, page: this.page.component})
      if (!res.success) 
        return false;
      return true
    },

    setComponentList(componentList) {
      this.componentList = componentList
    },

    selectTab(value) {
      let self = this;
      self.$emit("selectTab", value);
    },

    showList() {
      let self = this;
      self.$emit("showList");
    },
  },
};
</script>
<style lang="less" scoped>
@import "./componentChoose.css";
</style>